import { Grid, IconButton, Modal, Typography } from '@mui/material';
import { Box } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';


export const SentimentAnalysisModal = ({ open, onClose, aspects }) => {
  const comment = aspects?.find(a => a.type === "Comment")?.comment

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80vw',
        maxHeight: '80vh',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        overflowY: 'auto',
      }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
       {comment &&  <Typography fontSize={16} color="#000" fontWeight={500}>Message</Typography>}
        {comment && <Typography color="#202020" fontSize={14} whiteSpace={'wrap'}>{comment}</Typography>}
        {aspects && aspects.filter(a => a.type === "Rating").length > 0 &&   <Typography fontSize={16} color="#000" fontWeight={500} mt={2}>Aspects of the tour</Typography>}
        {aspects && aspects.filter(a => a.type === "Rating").map((aspect, index) => (
          <Grid container alignItems="center" key={index} spacing={1} mt={1}>
            <Grid item xs={8} maxWidth={'200px'}  whiteSpace={'wrap'}>
              <Typography fontSize={14} color="#202020">{aspect.name}</Typography>
            </Grid>
            <Grid item xs={4} container justifyContent="flex-end">
            <img style={{ width: '20px', height: '20px' }} alt={`Rating ${Math.floor(aspect.rating)}`} src={`/rating-emojis/rating-${Math.floor(aspect.rating)}.svg`} />
            </Grid>
          </Grid>
         ))}
      </Box>
    </Modal>
  );
};


export const CustomTooltip = ({ aspects }) => {
  const comment = aspects.find(a => a.type === "Comment")?.comment

  return (<div style={{ padding: '10px', backgroundColor: 'white', borderRadius: '12px', maxHeight:'60vh', overflowY:'auto' }}>
    {comment &&  <Typography fontSize={16} color="#000" fontWeight={500}>Message</Typography>}
    {comment && <Typography color="#202020" fontSize={14} whiteSpace={'wrap'}>{comment}</Typography>}
    {aspects.filter(a => a.type === "Rating").length > 0 &&   <Typography fontSize={16} color="#000" fontWeight={500} mt={comment ? 2 : 0}>Aspects of the tour</Typography>}
    {aspects.filter(a => a.type === "Rating").map((aspect, index) => (
      <Grid container alignItems="center" key={index} spacing={1} mt={1}>
        <Grid item xs={8} maxWidth={'200px'} whiteSpace={'wrap'}>
          <Typography fontSize={14} color="#202020">{aspect.name}</Typography>
        </Grid>
        <Grid item xs={4} container justifyContent="flex-end">
        <img style={{ width: '20px', height: '20px' }} alt={`Rating ${Math.floor(aspect.rating)}`} src={`/rating-emojis/rating-${Math.floor(aspect.rating)}.svg`} />
        </Grid>
      </Grid>
    ))}
  </div>)
};
